<div class="modal-dialog"
     id="new-request">
  <div class="modal-content p-0">
    <div class="modal-header">
      <button (click)="noAction()"
              class="close"
              data-dismiss="modal"
              type="button">
        <div class="dialog-close"></div>
      </button>
      <span>{{ 'AttributeSelector' | translate }}</span>
    </div>
  </div>
</div>
<mat-dialog-content class="mat-typography">
  <div class="row mt-3">
    <div class="col-md-4 col-12 row">
      <app-frontend-input [(value)]="attributeTitle"
                          [title]="'Title'"
                          [type]="'text'"></app-frontend-input>
    </div>
    <div class="col-md-2 col-12 row mt-1">
      <app-frontend-button (click)="onSelectAttributeTypeClicked(undefined,attributeTitle)"
                           [Image]="true"
                           [class]="'card-green'"
                           [src]="'/icons/search-normal.svg'"
                           [title]="'Search'">
      </app-frontend-button>
    </div>
  </div>
  <hr>
  <div class="row my-4 pb-1 ">
    <div class="col-md-4 border-start attribute-type-scroll-fixed">
      <div class="row my-0">
        <div (click)="onSelectAttributeTypeClicked(undefined)"
             [ngClass]="selectedType === undefined ? 'select-row' : 'dark'"
             class="col-12 d-flex justify-content-between align-items-center my-2 cursor-pointer">
          <div class="d-flex align-items-center">
            <span *ngIf="hasSomeSelectedAttributes()"
                  class="ms-1"
                  style="color: red">*</span>
            <p>{{ 'AllInformation' | translate }}</p>
          </div>
          <span>
            <img class="color-img"
                 src="/icons/arrow-left1.svg">
            </span>
        </div>
      </div>
      <div *ngFor="let type of attributeTypes;"
           class="row my-0">
        <div (click)="onSelectAttributeTypeClicked(type)"
             [ngClass]="(selectedType !== undefined && selectedType.AttributeTypeId === type.AttributeTypeId) ? 'select-row' : 'dark'"
             class="col-12 d-flex justify-content-between align-items-center py-3 cursor-pointer">
          <div class="d-flex align-items-center">
            <span *ngIf="type?.Status?.HasSelectedValue"
                  class="ms-1"
                  style="color: red">*</span>
            <p>{{ type.Title }}</p>
          </div>
          <span>
           <img class="color-img"
                src="/icons/arrow-left1.svg">
            </span>
        </div>
      </div>
    </div>
    <div class="col-md-8 attribute-scroll-fix">
      <div *ngIf="attributeResults.length>0">
        <div class="col-12">
          <app-frontend-check-box (valueChange)="onAttributeClicked($event)"
                                  [(value)]="selectAllValue"
                                  [title]="'همه'"></app-frontend-check-box>
        </div>
        <div *ngFor="let attr of attributeResults"
             class="col-12">
          <app-frontend-check-box (valueChange)="onChangeChecked(attr,$event)"
                                  [(value)]="attr.IsSelected"
                                  [title]="attr.AttributeTitle"></app-frontend-check-box>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<div class="dialog-footer">
  <mat-dialog-actions align="end"
                      class="py-0">
    <div class="col-12 d-flex align-items-center justify-content-end footer"
         style="gap: 16px">
      <app-frontend-button (click)="onSubmitClicked()"
                           [Image]="true"
                           [class]="'card-green'"
                           [disabled]="false"
                           [src]="'/icons/tick-square.svg'"
                           [title]="'Submit'">
      </app-frontend-button>
      <app-frontend-button (click)="noAction()"
                           [Image]="true"
                           [class]="'card-yellow'"
                           [disabled]="false"
                           [src]="'/icons/close-square.svg'"
                           [title]="'Cancel'">
      </app-frontend-button>
    </div>
  </mat-dialog-actions>
</div>
